import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { OrderQuery } from '@modules/order/state/order-query';
import { SoftwareOptionsService } from '@shared/services/software-options.service';
import { SoftwareOptions } from '@shared/models/enums/enums';
import { SendToIdForNotLabsEnum } from '@modules/order/models/send-to-type.enum';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { getSendToTypesFromOption } from '@shared/utils/send-to-utils';
import { TeethDiagramQuery } from '@modules/teeth-diagram/state/teeth-diagram-query';
import { IntuitiveIndication, toUnitType } from '@modules/rx-intuitive-teeth-orchestrator/models/intuitive-indication';

const CROWN_UNIT_TYPE = toUnitType(IntuitiveIndication.Crown);

@Injectable({
	providedIn: 'root'
})
export class CrownAiBannerVisibilityService {
	isVisible$: Observable<boolean> = combineLatest([
		this.softwareOptionsService.hasCompanySoftwareOption$(SoftwareOptions.DesignSuiteCrownAI),
		this.shellQuery.isReadOnly$,
		this.orderQuery.procedureMap$,
		this.orderQuery.sendTo$,
		this.teethDiagramQuery.teethFlat$
	]).pipe(
		map(([hasDesignSuiteCrownAISwo, isReadOnly, procedureMap, sendTo, teeth]) => {
			if (!hasDesignSuiteCrownAISwo || isReadOnly || !procedureMap || !sendTo || !teeth) {
				return false;
			}

			return (
				getSendToTypesFromOption(sendTo) === SendToIdForNotLabsEnum.midcOnly &&
				(procedureMap.ProcedureId as ProcedureEnum) === ProcedureEnum.FixedRestorative &&
				teeth.some(tooth => tooth.UnitTypeID === CROWN_UNIT_TYPE)
			);
		})
	);

	constructor(
		private readonly shellQuery: ShellQuery,
		private readonly orderQuery: OrderQuery,
		private readonly softwareOptionsService: SoftwareOptionsService,
		private readonly teethDiagramQuery: TeethDiagramQuery
	) {}
}
